import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React, { PropsWithChildren } from 'react';
import Link from 'next/link';
import IconSaveAs from '@/assets/icons/heroIcons/SaveAs.svg';
import { ButtonProps } from '../types';
import { addPrefixToDataParams } from '@/utils/string';
export function DownloadButton(props) {
  const $ = _c(21);
  const {
    analyticsParam,
    ariaLabel,
    className,
    children,
    disabled,
    onClick,
    testId,
    to,
    type: t0,
    variant
  } = props;
  const type = t0 === undefined ? "button" : t0;
  const t1 = variant !== "old" && "bg-blue-100 border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 active:bg-blue-700 active:border-blue-700 aria-disabled:text-white aria-disabled:bg-blue-200 aria-disabled:border-blue-200";
  const t2 = variant === "old" && "bg-light-gray-100 border-light-gray-500 hover:bg-light-gray-500 hover:border-light-gray-500 active:bg-light-gray-700 active:border-light-gray-700 aria-disabled:opacity-50";
  let t3;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2) {
    t3 = mergeClasses("w-full sm:w-auto sm:min-w-[21.5rem] max-w-full", "group inline-block border-2 text-md font-normal rounded-lg px-6 py-4 transition-colors aria-disabled:pointer-events-none", "focus-visible:outline-dotted focus-visible:ring-3 focus-visible:outline-blue-500 text-blue-500 hover:text-white active:text-white", t1, t2, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const fullClassName = t3;
  let t4;
  if ($[4] !== analyticsParam || $[5] !== testId) {
    t4 = addPrefixToDataParams({
      analyticsParam,
      testId,
      prefix: "btn"
    });
    $[4] = analyticsParam;
    $[5] = testId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const dataParams = t4;
  let t5;
  if ($[7] !== dataParams || $[8] !== fullClassName) {
    t5 = {
      className: fullClassName,
      ...dataParams
    };
    $[7] = dataParams;
    $[8] = fullClassName;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const commonProps = t5;
  let t6;
  if ($[10] !== children || $[11] !== variant) {
    t6 = function renderContent() {
      return <div className="flex flex-row items-center justify-between gap-4"><span className={mergeClasses(variant === "old" ? "text-gray-500" : "text-gray-900", "group-hover:text-white")}>{children}</span><IconSaveAs className="h-7 w-7 shrink-0" /></div>;
    };
    $[10] = children;
    $[11] = variant;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const renderContent = t6;
  let t7;
  if ($[13] !== ariaLabel || $[14] !== commonProps || $[15] !== disabled || $[16] !== onClick || $[17] !== renderContent || $[18] !== to || $[19] !== type) {
    t7 = to ? <Link {...commonProps} href={to} title={ariaLabel} target="_blank">{renderContent()}</Link> : <button {...commonProps} {...disabled && {
      "aria-disabled": true
    }} aria-label={ariaLabel} onClick={onClick} type={type}>{renderContent()}</button>;
    $[13] = ariaLabel;
    $[14] = commonProps;
    $[15] = disabled;
    $[16] = onClick;
    $[17] = renderContent;
    $[18] = to;
    $[19] = type;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}